"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

var _Border = _interopRequireDefault(require("./Border"));

var _CircleTicks = _interopRequireDefault(require("./CircleTicks"));

var _PolarAxes = _interopRequireDefault(require("./PolarAxes"));

var _DataPolygon = _interopRequireDefault(require("./DataPolygon"));

var _DataLabels = _interopRequireDefault(require("./DataLabels"));

var _QuadrantLabels = _interopRequireDefault(require("./QuadrantLabels"));

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TICK_COUNT = 6;

function dataMax(_ref) {
  var north = _ref.north,
      east = _ref.east,
      south = _ref.south,
      west = _ref.west;
  return Math.max(north.value, east.value, south.value, west.value);
} // Copy and add given domain to all scales


function applyScaleDomain(scales, domain) {
  var newScales = {};
  Object.keys(scales).forEach(function (key) {
    newScales[key] = scales[key].copy().domain(domain);
  });
  return newScales;
} // Initialize chart bounds


function initBounds(height, width, padding, show) {
  var bounds = {
    x: {
      min: padding,
      max: width - padding
    },
    y: {
      min: padding,
      max: height - padding
    }
  };
  var origin = {};

  if (show.west && show.east) {
    origin.x = width / 2;
  } else {
    origin.x = show.east ? bounds.x.min : bounds.x.max;
  }

  if (show.north && show.south) {
    origin.y = height / 2;
  } else {
    origin.y = show.south ? bounds.y.min : bounds.y.max;
  }

  return {
    origin: origin,
    bounds: bounds
  };
} // Initialize fluid scales utilizing all space between origin and bounds


function initFluidScales(origin, bounds) {
  return {
    north: d3.scaleLinear().range([origin.y, bounds.y.min]),
    east: d3.scaleLinear().range([origin.x, bounds.x.max]),
    south: d3.scaleLinear().range([origin.y, bounds.y.max]),
    west: d3.scaleLinear().range([origin.x, bounds.x.min])
  };
} // Initialize synchronized scales where shortest axis sets a universal upper limit


function initSyncedScales(origin, bounds, padding) {
  var xLimit = origin.x !== bounds.x.min && origin.x !== bounds.x.max ? Math.abs(bounds.x.max - origin.x) : bounds.x.max - bounds.y.min;
  var yLimit = origin.y !== bounds.y.min && origin.y !== bounds.y.max ? Math.abs(bounds.y.max - origin.y) : bounds.y.max - bounds.y.min;
  var commonLimit = Math.min(xLimit, yLimit);
  return {
    north: d3.scaleLinear().range([origin.y, origin.y - commonLimit + padding]),
    east: d3.scaleLinear().range([origin.x, origin.x + commonLimit - padding]),
    south: d3.scaleLinear().range([origin.y, origin.y + commonLimit - padding]),
    west: d3.scaleLinear().range([origin.x, origin.x - commonLimit + padding])
  };
} // Initialize synchronized scales and assign a maximized domain (based on data)


function initFitScales(origin, bounds, padding, data) {
  var xLimit = origin.x !== bounds.x.min && origin.x !== bounds.x.max ? Math.abs(bounds.x.max - origin.x) : bounds.x.max - bounds.y.min;
  var yLimit = origin.y !== bounds.y.min && origin.y !== bounds.y.max ? Math.abs(bounds.y.max - origin.y) : bounds.y.max - bounds.y.min;
  xLimit = xLimit - padding;
  yLimit = yLimit - padding;

  var collectOverflow = function collectOverflow(limit, value) {
    var domain = [0, value];
    var maxScales = {
      north: d3.scaleLinear().range([origin.y, origin.y - limit]),
      east: d3.scaleLinear().range([origin.x, origin.x + limit]),
      south: d3.scaleLinear().range([origin.y, origin.y + limit]),
      west: d3.scaleLinear().range([origin.x, origin.x - limit])
    };
    var scales = applyScaleDomain(maxScales, domain);
    var leftover = {};

    if (data.north) {
      leftover.north = yLimit - (scales.north(0) - scales.north(data.north.value));
    }

    if (data.east) {
      leftover.east = xLimit - (scales.east(data.east.value) - scales.east(0));
    }

    if (data.south) {
      leftover.south = yLimit - (scales.south(data.south.value) - scales.south(0));
    }

    if (data.west) {
      leftover.west = xLimit - (scales.west(0) - scales.west(data.west.value));
    }

    var hasOverflow = Object.values(leftover).some(function (v) {
      return v < 0;
    });

    if (!hasOverflow) {
      return {
        leftover: Object.values(leftover).reduce(function (acc, v) {
          return acc + v;
        }, 0),
        scales: scales
      };
    }
  };

  var candidates = [{
    limit: yLimit,
    value: data.north && data.north.value
  }, {
    limit: xLimit,
    value: data.east && data.east.value
  }, {
    limit: yLimit,
    value: data.south && data.south.value
  }, {
    limit: xLimit,
    value: data.west && data.west.value
  }];
  candidates = candidates.filter(function (c) {
    return c.value && c.value > 0;
  });
  var candidateList = candidates.map(function (c) {
    return collectOverflow(c.limit, c.value);
  }).filter(function (c) {
    return c;
  });
  var candidatesSorted = (0, _sortBy.default)(candidateList, function (c) {
    return -c.leftover;
  });
  return candidatesSorted[0].scales;
} // Extends the domain of all scales so that they start and end on nice round values


function makeScalesNice(_ref2) {
  var north = _ref2.north,
      east = _ref2.east,
      south = _ref2.south,
      west = _ref2.west;
  return {
    north: north.nice(TICK_COUNT),
    east: east.nice(TICK_COUNT),
    south: south.nice(TICK_COUNT),
    west: west.nice(TICK_COUNT)
  };
}

var PolarChart = /*#__PURE__*/function (_Component) {
  _inherits(PolarChart, _Component);

  var _super = _createSuper(PolarChart);

  function PolarChart() {
    _classCallCheck(this, PolarChart);

    return _super.apply(this, arguments);
  }

  _createClass(PolarChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          data = _this$props.data,
          primary = _this$props.primary,
          inverted = _this$props.inverted,
          show = _this$props.show,
          hatched = _this$props.hatched,
          round = _this$props.round,
          labels = _this$props.labels,
          sum = _this$props.sum;
      var hasCircleTicks = round;
      var hasOuterAxisLabels = round;
      var hasQuadrantLabels = labels;
      var hasBorder = !round;
      var outerPadding = 13;

      var _initBounds = initBounds(height, width, outerPadding, show),
          origin = _initBounds.origin,
          bounds = _initBounds.bounds;

      var max = data ? dataMax(data) : null;
      var axisScales, dataScales;

      if (round && data) {
        var dataPadding = 60;
        var domain = [0, max + 0.05];
        dataScales = initSyncedScales(origin, bounds, dataPadding);
        dataScales = applyScaleDomain(dataScales, domain);
        dataScales = makeScalesNice(dataScales);
        axisScales = dataScales;
      } else {
        var _dataPadding = 100;
        axisScales = initFluidScales(origin, bounds);
        dataScales = max ? initFitScales(origin, bounds, _dataPadding, data) : axisScales;
      }

      return /*#__PURE__*/_react.default.createElement("svg", {
        height: height,
        width: width
      }, /*#__PURE__*/_react.default.createElement(_Border.default, {
        bounds: bounds,
        hatched: hatched,
        hidden: !hasBorder
      }), /*#__PURE__*/_react.default.createElement(_CircleTicks.default, {
        origin: origin,
        scales: dataScales,
        hidden: !hasCircleTicks,
        inverted: inverted
      }), /*#__PURE__*/_react.default.createElement(_PolarAxes.default, {
        scales: axisScales,
        show: show,
        outerLabels: hasOuterAxisLabels,
        inverted: inverted
      }), /*#__PURE__*/_react.default.createElement(_DataPolygon.default, {
        scales: dataScales,
        data: data,
        show: show,
        sum: sum,
        primary: primary,
        inverted: inverted
      }), /*#__PURE__*/_react.default.createElement(_DataLabels.default, {
        scales: dataScales,
        data: data,
        show: show,
        inverted: inverted
      }), /*#__PURE__*/_react.default.createElement(_QuadrantLabels.default, {
        bounds: bounds,
        show: show,
        hidden: !hasQuadrantLabels
      }));
    }
  }]);

  return PolarChart;
}(_react.Component);

var dataDirection = {
  key: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.number.isRequired
};
PolarChart.propTypes = {
  data: _propTypes.default.shape({
    north: dataDirection,
    east: dataDirection,
    south: dataDirection,
    west: dataDirection
  }).isRequired,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  show: _propTypes.default.shape({
    north: _propTypes.default.bool,
    east: _propTypes.default.bool,
    south: _propTypes.default.bool,
    west: _propTypes.default.bool
  }),
  primary: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  round: _propTypes.default.bool,
  hatched: _propTypes.default.bool,
  sum: _propTypes.default.bool,
  labels: _propTypes.default.bool
};
PolarChart.defaultProps = {
  width: 560,
  height: 560,
  show: {
    north: true,
    east: true,
    south: true,
    west: true
  },
  primary: false,
  inverted: false,
  round: false,
  hatched: false,
  sum: false,
  labels: false
};

var _default = (0, _styledComponents.withTheme)(PolarChart);

exports.default = _default;
//# sourceMappingURL=PolarChart.js.map